export default __webpack_public_path__ + "static/form-button-feedback-do-ce250c50abd910f846e854e925269696.png";